import css from './nft-detail.module.scss';
import {Songs} from '../../components/songs/songs';
import {NFT_DETAIL_SETLIST} from './nft-detail.mock';
import {useNavigate} from '@tanstack/react-location';

export const NftDetail = (): JSX.Element => {
	const navigate = useNavigate();

	const navigateBack = () => {
		navigate({to: '/wallet'});
	};

	return (
		<div>
			<div className={css.imgContainer}>
				<img onClick={navigateBack} className={css.chevronLeft} src="img/chevron.left.svg" />
			</div>
			<div className={css.detail}>
				<h2>Khruangbin</h2>
				<div className={css.row}>
					<span>SHOW DATE</span>
					<span>Saturday, 31 Jan · 20:30</span>
				</div>
				<div className={css.row}>
					<span>VENUE</span>
					<span>City Winery NYC</span>
				</div>
			</div>

			<div className={css.songsContainer}>
				<h3>Your Voted Setlist</h3>
				<span>Voted 20 days ago</span>
				<Songs list={NFT_DETAIL_SETLIST} />
			</div>
		</div>
	);
};
